let iid = (new Date()).valueOf();
export const uid = () => iid++;
//# sourceMappingURL=helpers.js.map